module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAP+EKYaGhjUkADUcED0YDBQcAFEEBBwQCCQMABQQAD0AADEAAC0AACQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEHABIALAAAAAAgACAAAAW7oCSOZGmeaGpGbKS+K+nCcAQA4j3TqH3/Ot7JBwTuhBJi0YhM2lgQJfMVqLYAUAZjGaS2bI1Ga7tMvlgMx+9BaBmKouMqolAUCW00MJ76cgcJLA5KZkNXXAAJCBGDU3NhiD8CAiw/ciNjkUaVWD2an5dxOlKRX55Yh5oHCyw9Pl+kQAUtfZupRV8BtbYPpLm6p7acN4OtEsDBln4AUcY0vmGVtEi+CtKhNUuc2M+I3Dy+TcHO4nPk5egoIQA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadNE_S5.gif
// module id = Ys/g
// module chunks = 44